import { useEffect } from 'react';
import gtmService from '../../../../../utils/gtm';
import { usePingIdentityInfo } from '../usePingIdentityInfo';
import { SSO_LOGIN_PENDING_KEY } from '../../constants';

export function useSSOLoginTracking() {
  const { isLoggedIn, userId } = usePingIdentityInfo();

  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }

    const isPendingLogin = sessionStorage.getItem(SSO_LOGIN_PENDING_KEY);

    if (isPendingLogin) {
      gtmService.ga4SSOLoginComplete(userId);
      sessionStorage.removeItem(SSO_LOGIN_PENDING_KEY);
    } else {
      gtmService.pushUserID(userId);
    }
    // Runs once on mount — login completion / userID push is a page-load concern.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
